export const RIDE_TIMING = { venue: 9, approach: 13, discovery: 17, finish: 40 };
export function advanceRide(time, dt, state, paused) {
  if (paused || !["CRUISING", "APPROACHING"].includes(state)) return time;
  return Math.min(RIDE_TIMING.finish, time + dt);
}
